'use client'

import { useIsDesktop } from '@/_hooks/useBreakpoint';
import { useMediaQuery } from '@chakra-ui/react'
import React from 'react'
import FilterDesktop from './filter.desktop'
import FilterMobile from './filter.mobile'

const Filters = () => {
  const isDesktop = useIsDesktop()

  if (isDesktop) {
    return <FilterDesktop />
  } else {
    return <FilterMobile />
  }
}

export default Filters
